/**
 * Vuetify Theme options
 * Is imported by the styleguide to do its thing
 * This file needs to be kept in sync with Figma. Maybe we can use this https://github.com/jxnblk/figma-theme
 * NOTE: Other colours are defined in the vuetify defaults, this list is merged with those
 * WARNING: Vuetify creates 20 (20!) colours and classes for each colour in this list. Go easy.
 * @see https://vuetifyjs.com/en/framework/theme
 */

const hsl = require('hsl-to-hex');

export default {
  primary: '#1F5673',
  secondary: '#F2F2F2',
  accent: '#F78F1E',
  info: {
    darken4: hsl(208, 79, 32),
    darken3: hsl(208, 79, 39),
    darken2: hsl(208, 78, 43),
    darken1: hsl(208, 79, 50),
    base: hsl(208, 79, 55),
    lighten1: hsl(208, 85, 65),
    lighten2: hsl(208, 90, 78),
    lighten3: hsl(210, 95, 88),
    lighten4: hsl(216, 71, 97),
    lighten5: hsl(216, 71, 99),
  },
  success: {
    darken4: hsl(122, 39, 20),
    darken3: hsl(122, 39, 38),
    darken2: hsl(122, 39, 35),
    darken1: hsl(122, 39, 42),
    base: hsl(122, 39, 49),
    lighten1: hsl(122, 39, 60),
    lighten2: hsl(121, 35, 70),
    lighten3: hsl(121, 35, 80),
    lighten4: hsl(120, 33, 98),
    lighten5: hsl(120, 33, 99),
  },
  error: {
    darken4: hsl(0, 80, 40),
    darken3: hsl(0, 80, 45),
    darken2: hsl(0, 85, 48),
    darken1: hsl(0, 90, 60),
    base: hsl(0, 100, 65),
    lighten1: hsl(2, 100, 70),
    lighten2: hsl(3, 90, 75),
    lighten3: hsl(3, 90, 80),
    lighten4: hsl(7, 80, 98),
    lighten5: hsl(7, 80, 99),
  },
  warning: {
    darken4: hsl(47, 80, 28),
    darken3: hsl(47, 85, 30),
    darken2: hsl(47, 95, 40),
    darken1: hsl(47, 100, 50),
    base: hsl(47, 100, 61),
    lighten1: hsl(47, 100, 70),
    lighten2: hsl(45, 100, 72),
    lighten3: hsl(45, 100, 80),
    lighten4: hsl(42, 100, 98),
    lighten5: hsl(42, 100, 99),
  },
  neutral: {
    darken4: hsl(217, 11, 15),
    darken3: hsl(195, 9, 23),
    darken2: '#677377',
    darken1: hsl(195, 6, 56),
    base: hsl(195, 9, 71),
    lighten1: hsl(195, 9, 83),
    lighten2: hsl(200, 11, 89),
    lighten3: hsl(205, 10, 93),
    lighten4: hsl(205, 15, 95),
    lighten5: hsl(205, 17, 98),
  },
  grey: '#dedddf',
  purple: '#8830D4',
  yellow: '#FFC300',
  pink: '#F118A9',
  blue: '#185AF1',
  crimsom: '#990C32',
  dark_green: '#0F8A2D',
  dark_purple: '#570E83',
  dark_blue: '#0E1583',
  light_blue: '#2EC0DE',
  green_grey: '#83AD92',
  purple_grey: '#AC87AE',
};
